var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTiktok = function SvgTiktok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 18,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tiktok_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#081B36",
    fillOpacity: 0.5,
    d: "M7.878.514C8.821.5 9.756.507 10.692.5a4.38 4.38 0 0 0 1.258 2.954A5.1 5.1 0 0 0 15 4.722v2.854a7.8 7.8 0 0 1-3.021-.687 9 9 0 0 1-1.165-.658c-.007 2.068.006 4.137-.015 6.198a5.36 5.36 0 0 1-2.822 4.427 5.4 5.4 0 0 1-2.4.637 5.3 5.3 0 0 1-2.936-.73 5.4 5.4 0 0 1-1.8-1.714 5.3 5.3 0 0 1-.826-2.33 13 13 0 0 1-.007-1.055c.073-.727.298-1.43.658-2.068a5.4 5.4 0 0 1 1.44-1.64 5.45 5.45 0 0 1 1.984-.94 5.5 5.5 0 0 1 2.2-.084c.014 1.048-.03 2.097-.03 3.145a2.5 2.5 0 0 0-1.892.106c-.293.14-.555.335-.77.574-.217.24-.382.519-.488.822-.113.37-.147.758-.101 1.14.093.585.402 1.114.866 1.49a2.47 2.47 0 0 0 1.652.544 2.45 2.45 0 0 0 1.143-.322c.348-.199.64-.48.85-.819.16-.222.261-.48.295-.75.071-1.269.043-2.53.05-3.797.007-2.855-.007-5.702.014-8.55"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tiktok_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .5h15v17H0z"
  })))));
};
export default SvgTiktok;